<template>
  <div v-if="testimonial" class="bg-putty">
    <div class="lg:grid-cols-2 py-14 lg:container lg:py-12 lg:px-0 grid items-center content-center grid-cols-1 px-4">
      <FixedAspect :ratio="0.76" class="sm:block lg:hidden order-first object-cover w-full">
        <CldnImg v-if="imageSrc" :src="imageSrc" crop="fill" sizes="350px md:770px" class="object-cover" />
      </FixedAspect>
      <FixedAspect :ratio="1.18" class="expert-picture lg:block order-last hidden w-full h-full">
        <CldnImg v-if="imageSrc" :src="imageSrc" crop="fill" sizes="50vw 2xl:648px" />
      </FixedAspect>
      <div class="bg-blackly lg:py-52 lg:px-16 lg:h-full lg:flex lg:flex-col lg:justify-center px-8 pt-10 pb-20">
        <span class="text-br-green fluid-xs leading-tightest font-semibold">
          {{ testimonial.authorName ?? $t('shop.ourExperts') }}
        </span>
        <div
          class="content text-copy fluid-lg lg:fluid-base font-light lg:leading-9 lg:mt-4 mt-2 leading-6 text-white"
          v-html="testimonial.body"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';

export default defineNuxtComponent({
  components: {
    FixedAspect,
    CldnImg,
  },
  props: {
    testimonials: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    testimonial() {
      return this.testimonials && this.testimonials[0] ? this.testimonials[0] : null;
    },
    imageSrc() {
      return this.testimonial?.authorImage?.[0]?.url || null;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.content :deep(p:nth-child(2)) {
  @apply mt-5 leading-normal;
}

.content :deep(strong) {
  @apply fluid-xs leading-tightest text-br-green-light;
}

.expert-picture :deep(*) {
  @apply h-full;
}
</style>
